import React from "react"
import SummaryProductInfo from "@irati-web/flexi-rewards/src/components/MerchandiseOrderSummary/SummaryProductInfo"
import {AddressInfo} from "@irati-web/flexi-rewards/src/components/OrderAddressInfo/AddressInfo"
import {CheckoutRedemption, Deal} from "@irati/types"
import {Row} from "@irati/ui/src/ColumnRow"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {Card, Hr} from "@irati/ui/src/Layout"
import {Body, H3} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import moment from "moment"
import Link from "@irati/ui/src/Link"
import MerchandiseStatus from "./MerchandiseStatus"

interface Props extends InjectIntl {
  redemption: CheckoutRedemption
}

const MerchandiseSummary = ({redemption, formatMessage}: Props) => {
  const {uuid, dateUnix, order, dealSnapshot} = redemption
  const {basket, products} = order!
  const {cardImage, header} = dealSnapshot as Required<Deal>
  const [product] = products!
  const [item] = product.items!

  return (
    <Flex direction="column">
      <H3 textAlign="center">
        <FormattedMessage id="perks.components.myPerks.merchSummary.title" />
      </H3>

      <Flex justifyContent="space-between" margin={[theme.spacing.three, 0]}>
        <div>
          <Body small weight="bold">
            <FormattedMessage id="perks.components.myPerks.merchSummary.orderDate" />
          </Body>

          <Body small marginTop={theme.spacing.one}>
            {moment.unix(dateUnix).format("DD/MM/YY")}
          </Body>
        </div>
        <div>
          <Body small weight="bold">
            <FormattedMessage id="perks.components.myPerks.merchSummary.orderNum" />
          </Body>

          <Body small marginTop={theme.spacing.one}>
            #{item.code}
          </Body>
        </div>
      </Flex>

      <Card>
        <Body small weight="bold" marginBottom={theme.spacing.three}>
          <FormattedMessage id="perks.components.myPerks.merchSummary.deliveryDetails" />
        </Body>

        <Row>
          <AddressInfo shippingAddress={basket!.shippingAddress!} small />
        </Row>

        <MerchandiseStatus redemptionId={uuid!} />
      </Card>

      <Card marginTop={theme.spacing.three}>
        <Body small weight="bold" marginBottom={theme.spacing.three}>
          <FormattedMessage id="perks.components.myPerks.merchSummary.item" />
        </Body>
        <SummaryProductInfo cardImage={cardImage} header={header} productImgOpts={{withOverlay: false, extraSmall: true}} />

        <Hr />

        <Flex justifyContent="space-between" alignItems="center">
          <Body weight="bold">
            <FormattedMessage id="perks.components.myPerks.merchSummary.total" />
          </Body>
          <Body weight="bold">
            <FormattedCurrency isCents currency={basket?.total?.currency} value={basket?.total?.amount} />
          </Body>
        </Flex>
      </Card>

      <Body small weight="bold" marginTop={3}>
        <FormattedMessage id="perks.components.myPerks.merchSummary.help" />
      </Body>
      <Card marginTop={1} padding={2}>
        <Link rel="noopener noreferrer" target="__blank" href={formatMessage({id: "perks.components.myPerks.merchSummary.faqUrl"})}>
          <FormattedMessage id="perks.components.myPerks.merchSummary.faq" />
        </Link>
      </Card>
    </Flex>
  )
}

export default injectIntl(MerchandiseSummary)
